module.exports = "/_next/static/media/2efa3dde87eff69a4c7b2283520d5fea.svg";